import {PageSubContainerSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function RolePermissionsPending() {
  return (
    <PageSubContainerSkeleton>
      <Skeleton className="h-8 w-48 rounded-md" />
      <Skeleton className="h-10 w-full rounded-md" />
    </PageSubContainerSkeleton>
  );
}
